import React from 'react';
import classNames from 'classnames';

function NavbarLeft(props) {
  const { className = null, children, ...otherProps } = props;
  const classes = classNames('ws-navbar__left', className);

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
}

export default NavbarLeft;
